import { enableUsageProjectionUi } from '@gonfalon/dogfood-flags/dogfood-flags';

import { AggregationType, Granularity } from '../../types';
import type { UsageTabKey } from '../../types';
import { usageTabConfig } from '../constants/usageTabConfig';

export function shouldShowProjection(
  tab: UsageTabKey,
  aggregationType: AggregationType,
  granularity: Granularity,
  projectedSeriesLength: number,
): boolean {
  const { hasProjectionData } = usageTabConfig[tab];
  return (
    !!hasProjectionData &&
    enableUsageProjectionUi() &&
    aggregationType === AggregationType.MONTH_TO_DATE &&
    granularity === Granularity.DAILY &&
    projectedSeriesLength > 0
  );
}
